import { render, staticRenderFns } from "./AppDownload.vue?vue&type=template&id=bfc3df76&scoped=true"
import script from "./AppDownload.vue?vue&type=script&lang=js"
export * from "./AppDownload.vue?vue&type=script&lang=js"
import style0 from "./AppDownload.vue?vue&type=style&index=0&id=bfc3df76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc3df76",
  null
  
)

export default component.exports